import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from '../../features/blogs/blogsSlice';

function Sidebar() {
  //Variable
  const dispatch = useDispatch();
  //States
  const [sortValue, setSortValue] = useState("default");
  const [filterValue, setFilterValue] = useState("all");

  //Hooks

  useEffect(() => {
    dispatch(fetchBlogs({ sortValue, filterValue }));
  }, [dispatch, sortValue, filterValue]);

  //Function
  const handleSortFilterChange = (event) => {
    const { name, value } = event.target;
    if (name === "sort") {
      setSortValue(value);
    } else if (name === "filter") {
      setFilterValue(value);
    }
  }


  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select name="sort" id="lws-sort" className="w-full max-w-[150px] border-2 rounded-md text-gray-500" value={sortValue} onChange={handleSortFilterChange}>
            <option value="default">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            <div>
              <input type="radio" name="filter" id="lws-all" className="radio" value="all" checked={filterValue === "all"} onChange={handleSortFilterChange} />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input type="radio" name="filter" id="lws-saved" className="radio" value="saved" checked={filterValue === "saved"} onChange={handleSortFilterChange} />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  )
}

export default Sidebar